export default __webpack_public_path__ + "static/media/c1c2e93de70a8bba7cd661e4963204b9.svg";